import { render, staticRenderFns } from "./comWxPhone.vue?vue&type=template&id=69cc5ad5&scoped=true&"
import script from "./comWxPhone.vue?vue&type=script&lang=js&"
export * from "./comWxPhone.vue?vue&type=script&lang=js&"
import style0 from "./comWxPhone.vue?vue&type=style&index=0&id=69cc5ad5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69cc5ad5",
  null
  
)

export default component.exports